<template>
  <div class="container">
    <div class="yidaFont" v-text='qaItem.answerCount > 0?"已答":"未答"'></div>
    <div class="title" :title="qaItem.title">{{ qaItem.title }}</div>
    <div class="desc">
      <span>
        <span style="margin-left:2px"><i class="el-icon-view" style="font-weight:600"></i> {{ qaItem.readCount }}</span>
        <span><i class="el-icon-edit" style="font-weight:600"></i> {{ qaItem.commentCount }}</span>
        <span><i class="el-icon-star-on" style="font-weight:600"></i> {{ qaItem.collectCount }}</span>
      </span>

      <span class="write"  @click="goPage('/answerInfo',qaItem.id)">
        <span style="margin: 0;" v-if="linkFrom !='space'">查看</span>
      </span>

    </div>
    <div class="best">最佳答案</div>
    <div class="content">
      {{ !qaItem.bestAnswer?'无': qaItem.bestAnswer.length>19? qaItem.bestAnswer.substring(0,19): qaItem.bestAnswer}}
    </div>
    <!-- <div class="seeDetails" :style="linkFrom=='space'?'margin-left: -100px;':''"  @click="goPage('/answerInfo',qaItem.id)">查看详情</div> -->
  </div>
</template>
<script>
export default {
  name: "AnswerV",
  data() {
    return {
      pageCount: "",
    };
  },
  props: ["qaItem", "linkFrom"],
  methods: {
    goPage(url,id) {
      this.$router.push(url+"?id="+id);
    },
  },
};
</script>
<style lang="stylus" scoped>
.container {
  padding: 12px;
  // border:1px solid red;
  background: #fff;
  border-radius: 4px;
  margin-bottom: 15px;

  .yidaFont {
    height: 14px;
    font-size: 10px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #999999;
    line-height: 10px;
    float: right;
  }

  .title {
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #363636;
    line-height: 28px;
    margin-bottom: 8px;
    padding-top: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .desc {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 400;
    color: #B8B9BA;
    line-height: 17px;

    span {
      white-space: nowrap;
      margin-right: 20px;
    }

    .write {
      width: 86px;
      height: 30px;
      background: #F02F2F;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
      margin-right: 10px;
    }
  }

  .best {
    margin: 5px 0px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #363636;
    line-height: 20px;
  }

  .content {
    width: 99%;
    height: -1px;
    line-height: 17px;
    color: #666666;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  // padding-right:3px;
  .seeDetails {
    position: relative;
    // top: -20px;
    // left: 295px;
    font-size: 14px;
    font-weight: 400;
    color: #237BFF;
    line-height: 20px;
    cursor: pointer;
  }
}
</style>
